module.exports = __webpack_public_path__ + "media/images/pages/peel/peel-4-52744a117470dd4d3b658bb99fb0f443.png";